import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/field-templates/{fieldKey}/debug-responses']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getFieldResponseDebug = async ({
  questionnaireId,
  fieldKey,
  page,
  perPage,
  row,
  listFieldKey,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath('/questionnaires/{questionnaireId}/field-templates/{fieldKey}/debug-responses', {
    fieldKey,
    questionnaireId,
  });
  const data = await formsBackendClient.get(path, {
    params: {
      listFieldKey,
      page,
      perPage,
      row,
    },
  });
  return data.data;
};

export default getFieldResponseDebug;
